import useFeatureFlags from '@modules/core/hooks/useFeatureFlags';
import { setAdditionalUserParams } from '@shared/analytics/amplitude';

export const ANNOUNCEMENTS = {
  referAndEarn: {
    featureFlag: 'announcements.referAndEarn',
    seenKey: 'announcements.referAndEarn.2025-09.seen',
  },
};

const useAnnouncements = (announcement: keyof typeof ANNOUNCEMENTS): [boolean, () => void] => {
  const { isFeatureActive, isFeatureFlagsLoading } = useFeatureFlags();

  const isAnnouncementsLoading: boolean = isFeatureFlagsLoading;

  const showAnnouncement: boolean = !isAnnouncementsLoading
    && isFeatureActive(ANNOUNCEMENTS[announcement].featureFlag);

  const markAnnouncementAsSeen = (): void => {
    setAdditionalUserParams({ [ANNOUNCEMENTS[announcement].seenKey]: Date.now() });
  };

  return [showAnnouncement, markAnnouncementAsSeen];
};

export default useAnnouncements;
